// Ana İçerik Aggregator
// Tüm seviyelerin içeriklerini birleştirir

import { A0_LEVEL } from './kariyerContentsA0Level';
import { A1_LEVEL } from './kariyerContentsA1Level';
import { A2_LEVEL } from './kariyerContentsA2Level';
import { B1_LEVEL } from './kariyerContentsB1Level';
import { B1INT_LEVEL } from './kariyerContentsB1INTLevel';
import { B2_LEVEL } from './kariyerContentsB2Level';
import { B2INT_LEVEL } from './kariyerContentsB2INTLevel';
import { C1_LEVEL } from './kariyerContentsC1Level';
import { C1INT_LEVEL } from './kariyerContentsC1INTLevel';
// Diğer seviyeler eklenecek
// import { CCT_LEVEL } from './kariyerContentsCCTLevel';

export const LESSON_CONTENTS = {
  ...A0_LEVEL,
  ...A1_LEVEL,
  ...A2_LEVEL,
  ...B1_LEVEL,
  ...B1INT_LEVEL,
  ...B2_LEVEL,
  ...B2INT_LEVEL,
  ...C1_LEVEL,
  ...C1INT_LEVEL,
  // ...CCT_LEVEL,
};

// Yardımcı fonksiyon: Ders içeriğini al
export const getLessonContent = (levelId, unitId, lessonId) => {
  // levelId format: "0", "1", "2"... veya "level_0", "level_1"...
  const normalizedLevelId = levelId.toString().replace('level_', '');
  
  // Level prefix belirleme - Yeni sıralama
  const levelPrefixes = {
    '0': 'A0',
    '1': 'A1', 
    '2': 'A2',
    '3': 'B1',
    '4': 'B1INT',  // B1 Interview Training
    '5': 'B2',
    '6': 'B2INT',  // B2 Interview Training
    '7': 'C1',
    '8': 'C1INT'   // C1 Interview Training
  };
  
  const prefix = levelPrefixes[normalizedLevelId] || 'A0';
  
  // Ders ID'sini oluştur
  const possibleIds = [
    `${prefix}-U${unitId}-L${lessonId}`,  // Normal ders: A0-U1-L1
    `${prefix}-U${unitId}-EXAM`,           // Ünite sınavı: A0-U1-EXAM
    `${prefix}-FINAL`,                     // Final sınavı: A0-FINAL
  ];
  
  for (const id of possibleIds) {
    if (LESSON_CONTENTS[id]) {
      return LESSON_CONTENTS[id];
    }
  }
  
  return null;
};

// Get all lesson contents for bulk import
export const getAllLessonContents = () => {
  const allContents = {};
  
  for (const [levelId, levelData] of Object.entries(LESSON_CONTENTS)) {
    if (levelData && typeof levelData === 'object') {
      for (const [unitId, unitData] of Object.entries(levelData)) {
        if (unitData && typeof unitData === 'object') {
          for (const [lessonId, content] of Object.entries(unitData)) {
            if (content) {
              const key = `${levelId}-${unitId}-${lessonId}`;
              allContents[key] = content;
            }
          }
        }
      }
    }
  }
  
  return allContents;
};

export default LESSON_CONTENTS;
